(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7639],{

/***/ 91433:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company",
      function () {
        return __webpack_require__(20479);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 20479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Company; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./components/common/layout-container.tsx
var layout_container = __webpack_require__(50336);
// EXTERNAL MODULE: ./components/common/grid-pattern-dark.tsx
var grid_pattern_dark = __webpack_require__(54774);
// EXTERNAL MODULE: ./components/common/rounded-corner.tsx
var rounded_corner = __webpack_require__(77510);
// EXTERNAL MODULE: ./node_modules/react/cjs/react.production.min.js
var react_production_min = __webpack_require__(72408);
// EXTERNAL MODULE: ./pages/index.tsx + 31 modules
var pages = __webpack_require__(16263);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(52494);
;// CONCATENATED MODULE: ./components/common/icons/smiley.js

function SmileyIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12.8284 12.8284C11.2663 14.3905 8.73367 14.3905 7.17157 12.8284M7 8H7.01M13 8H13.01M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z",
            stroke: "white",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    });
}

;// CONCATENATED MODULE: ./components/common/icons/puzzle-piece.js

function PuzzlePieceIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10 3C10 1.89543 10.8954 1 12 1C13.1046 1 14 1.89543 14 3V4C14 4.55228 14.4477 5 15 5H18C18.5523 5 19 5.44772 19 6V9C19 9.55228 18.5523 10 18 10H17C15.8954 10 15 10.8954 15 12C15 13.1046 15.8954 14 17 14H18C18.5523 14 19 14.4477 19 15V18C19 18.5523 18.5523 19 18 19H15C14.4477 19 14 18.5523 14 18V17C14 15.8954 13.1046 15 12 15C10.8954 15 10 15.8954 10 17V18C10 18.5523 9.55228 19 9 19H6C5.44772 19 5 18.5523 5 18V15C5 14.4477 4.55228 14 4 14H3C1.89543 14 1 13.1046 1 12C1 10.8954 1.89543 10 3 10H4C4.55228 10 5 9.55228 5 9V6C5 5.44772 5.44772 5 6 5H9C9.55228 5 10 4.55228 10 4V3Z",
            stroke: "white",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    });
}

;// CONCATENATED MODULE: ./components/common/icons/fingerprint.js

function FingerPrintIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "19",
        height: "20",
        viewBox: "0 0 19 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.99987 9C9.99987 12.5172 8.99109 15.7988 7.24707 18.5712M3.80688 16.5304C3.82459 16.5005 3.84273 16.4709 3.8613 16.4413C5.2158 14.2881 5.99991 11.7418 5.99991 9C5.99991 6.79086 7.79077 5 9.99991 5C12.209 5 13.9999 6.79086 13.9999 9C13.9999 10.017 13.9307 11.0186 13.7966 12M11.6792 18.8436C12.2909 17.6226 12.7924 16.3369 13.1707 15M17.0097 16.132C17.6547 13.8657 18 11.4732 18 9C18 4.58172 14.4183 1 10 1C8.54285 1 7.17669 1.38958 6 2.07026M1 13.3641C1.64066 12.0454 2 10.5646 2 9C2 7.54285 2.38958 6.17669 3.07026 5",
            stroke: "white",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    });
}

;// CONCATENATED MODULE: ./components/company/hero.tsx



const IconSection = (param)=>{
    let { icon , title , text  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* VStack */.gC, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                bg: "primary.500",
                color: "white",
                h: "44px",
                w: "44px",
                rounded: "md",
                mb: "18px",
                mt: "24px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                    h: "24px",
                    w: "24px",
                    as: icon
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                fontSize: "24px",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                maxW: "270px",
                children: text
            })
        ]
    });
};
const Hero = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
        align: "center",
        justifyContent: "center",
        textAlign: "center",
        spacing: 4,
        h: {
            base: "auto",
            md: "100vh"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                as: "h2",
                size: "md",
                color: "primary.500",
                children: "Our Mission"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Heading */.X6, {
                as: "h1",
                size: "h1",
                children: [
                    "It all starts with the",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                        as: "span",
                        bgGradient: "linear-gradient(271.19deg, #17CCFC -28.89%, #6C47FF 80.53%)",
                        bgClip: "text",
                        children: "user."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Stack */.Kq, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                    fontSize: "xl",
                    maxW: "600px",
                    children: [
                        "We solve user management so developers can",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: "stop re-inventing the wheel"
                        }),
                        " and focus on their core business."
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                flexDir: {
                    base: "column",
                    md: "row"
                },
                gap: {
                    base: 6,
                    md: 12
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSection, {
                        icon: SmileyIcon,
                        title: "Easy",
                        text: "Use Clerk's fully featured UIs and dead simple APIs to add authentication in minutes instead of months."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSection, {
                        icon: PuzzlePieceIcon,
                        title: "Integrative",
                        text: "At Clerk, we believe a component is worth 1,000 APIs and that they should work seamlessly in any stack so that you can build faster."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSection, {
                        icon: FingerPrintIcon,
                        title: "Secure",
                        text: "Clerk is SOC 2 type certified, GDPR & CCPA compliant, and conducts regular third-party audits and pen testing."
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/company/investors.tsx




const InvestorDetailsCard = (param)=>{
    let { logo , name , tagline , description  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Flex */.kC, {
        w: "full",
        h: "150px",
        bg: "white",
        p: "24px",
        justifyContent: "center",
        alignItems: "center",
        rounded: "lg",
        boxShadow: "0px 2px 6px rgba(57, 67, 86, 0.08)",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
            w: "397.1",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                    pr: "16px",
                    pt: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: logo,
                        alt: "",
                        height: 72,
                        width: 72
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                    flexDir: "column",
                    alignContent: "space-between",
                    justifyContent: "space-between",
                    h: "full",
                    letterSpacing: "-0.02em",
                    fontFamily: "heading",
                    minH: "95px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                            fontSize: "16px",
                            lineHeight: "24px",
                            fontWeight: 700,
                            children: name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                            fontSize: "12px",
                            lineHeight: "15px",
                            maxW: "261px",
                            fontWeight: 500,
                            minH: "45px",
                            children: tagline
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                            fontWeight: 300,
                            lineHeight: "12px",
                            mt: "6px",
                            fontSize: "12px",
                            fontStyle: "normal",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
};
const InvestorLogoCard = (param)=>{
    let { logo  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
        h: "80px",
        w: "full",
        maxW: "195px",
        bg: "white",
        px: "24px",
        py: "9px",
        justifyContent: "center",
        alignItems: "center",
        rounded: "lg",
        mt: "19px",
        mb: "40px",
        boxShadow: "0px 2px 6px rgba(57, 67, 86, 0.08)",
        children: [
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: logo,
                alt: "",
                height: 62,
                width: 148
            })
        ]
    });
};
const InvestorProfileCard = (param)=>{
    let { image , name , title , social  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
        bg: "white",
        p: "20px",
        w: "180px",
        flexDir: "column",
        justifyContent: "center",
        alignItems: "center",
        letterSpacing: "-0.02em",
        rounded: "lg",
        boxShadow: "0px 2px 6px rgba(57, 67, 86, 0.08)",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                rounded: "full",
                overflow: "hidden",
                mx: "44px",
                mb: "16px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: image,
                    alt: "",
                    width: 64,
                    height: 64
                })
            }),
            social ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: social,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                    fontWeight: 700,
                    fontFamily: "heading",
                    fontSize: "14px",
                    color: "black",
                    children: name
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                fontWeight: 700,
                fontFamily: "heading",
                fontSize: "14px",
                color: "black",
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                fontFamily: "heading",
                whiteSpace: "nowrap",
                children: title
            })
        ]
    });
};
const Investors = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
        justifyContent: "center",
        alignItems: "center",
        flexDir: "column",
        pt: {
            base: "60px",
            md: 0
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                pos: "relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                    size: "h1",
                    textAlign: "center",
                    mb: "60px",
                    children: "Funded by industry-leading investors."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                flexDir: {
                    base: "column",
                    lg: "row"
                },
                gap: "32px",
                mb: "16px",
                zIndex: 10,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestorDetailsCard, {
                        logo: "/images/logos/madrona.svg",
                        name: "Madrona",
                        tagline: "Backing founding teams in seed, early, and acceleration stages in the Pacific Northwest and beyond.",
                        description: "Investor in Amazon, Branch, and more."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestorDetailsCard, {
                        logo: "/images/logos/a16z.svg",
                        name: "Andreessen Horowitz",
                        tagline: "Backing bold entrepreneurs building the future through technology.",
                        description: "Investor in Lyft, Slack, Github, and more."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestorDetailsCard, {
                        logo: "/images/logos/s28.svg",
                        name: "S28 Capital",
                        tagline: "A venture capital firm focused on investing in companies disrupting long-standing industries.",
                        description: "Investor in Rippling, Vercel, Bricks, and more."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                flexWrap: "wrap",
                gap: {
                    base: "6px",
                    lg: "16px"
                },
                zIndex: 10,
                justifyContent: "center",
                mt: {
                    base: "12px",
                    lg: ""
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestorLogoCard, {
                        logo: "/images/logos/fathom.svg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestorLogoCard, {
                        logo: "/images/logos/southparkcommons.svg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestorLogoCard, {
                        logo: "/images/logos/mango.svg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestorLogoCard, {
                        logo: "/images/logos/netlify.svg"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                pt: "80px",
                pb: "60px",
                textAlign: "center",
                children: "Individual investors"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                flexWrap: "wrap",
                gap: "24px",
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestorProfileCard, {
                        image: "/avatars/investors/guillermo-rauch.svg",
                        name: "Guillermo Rauch",
                        title: "Founder of Vercel",
                        social: "https://twitter.com/rauchg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestorProfileCard, {
                        image: "/avatars/investors/andrew-miklas.svg",
                        name: "Andrew Miklas",
                        title: "Founder of PagerDuty",
                        social: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestorProfileCard, {
                        image: "/avatars/investors/darragh-buckley.svg",
                        name: "Darragh Buckley",
                        title: "Founder of Increase",
                        social: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestorProfileCard, {
                        image: "/avatars/investors/ilya-volodarsky.svg",
                        name: "Ilya Volodarsky",
                        title: "Founder of Segment",
                        social: "https://twitter.com/ivolo"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestorProfileCard, {
                        image: "/avatars/investors/calvin-french-owen.svg",
                        name: "Calvin French-Owen",
                        title: "Founder of Segment",
                        social: "https://twitter.com/calvinfo"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestorProfileCard, {
                        image: "/avatars/investors/gordon-wintrob.svg",
                        name: "Gordon Wintrob",
                        title: "Founder of Newfront",
                        social: "https://twitter.com/gwintrob"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestorProfileCard, {
                        image: "/avatars/investors/max-kanter.svg",
                        name: "Max Kanter",
                        title: "Creator of FeatureTools",
                        social: "https://twitter.com/maxk"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestorProfileCard, {
                        image: "/avatars/investors/dave-wilner.svg",
                        name: "Dave Wilner",
                        title: "CRO of Auth0",
                        social: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestorProfileCard, {
                        image: "/avatars/investors/max-stoiber.svg",
                        name: "Max Stoiber",
                        title: "Founder of Stellate",
                        social: "https://twitter.com/mxstbr"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestorProfileCard, {
                        image: "/avatars/investors/laduram-vishnoi.svg",
                        name: "Ladurum Vishnoi",
                        title: "Founder of Middleware",
                        social: "https://twitter.com/laduramvishnoi"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestorProfileCard, {
                        image: "/avatars/investors/amrit-dhangal.svg",
                        name: "Amrit Dhangal",
                        title: "Founder of Acquire",
                        social: "https://twitter.com/AmritDhangal"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/company.tsx







function Company() {
    (0,react_production_min.useEffect)(()=>{
        pages.analytics.track("Marketing_About_ Viewed", {
            surface: "Marketing",
            location: "About"
        });
    }, []);
    // const [shouldRender, setShouldRender] = useState(false);
    // useEffect(() => {
    //   setShouldRender(true);
    // }, []);
    // // Workaround to prevent `Hydration failed because the initial UI does not match what was rendered on the server.`
    // if (!shouldRender) return <Box h="100vh" w="100vw"></Box>;
    const [isShorterThan920] = (0,index_esm/* useMediaQuery */.ac)("(max-height: 920px)");
    const [isSmallerThan770] = (0,index_esm/* useMediaQuery */.ac)("(max-width: 770px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_container/* LayoutContainer */.k, {
        verticalPadding: "none",
        pos: "relative",
        bgGradient: "linear(to-br, #E8E4FF 0%, #F6F9FC 40%, #E5F7FF 100% )",
        pt: {
            base: "120px",
            md: "0px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* AspectRatio */.oM, {
                ratio: 1400 / 1190,
                w: "1400px",
                pos: "absolute",
                zIndex: 0,
                top: "200px",
                left: "10%",
                pointerEvents: "none",
                draggable: false,
                userSelect: "none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_pattern_dark/* GridPatternDark */.H, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
                gap: "120px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Investors, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                        flexDir: {
                            base: "column",
                            md: "row"
                        },
                        alignItems: "center",
                        justifyContent: "space-evenly",
                        pos: "relative",
                        gap: {
                            base: 4,
                            md: 0
                        },
                        pb: "120px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                as: "h1",
                                w: {
                                    sm: "400px"
                                },
                                textAlign: {
                                    base: "center",
                                    md: "left"
                                },
                                children: "Come build with the best."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                w: "25%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "https://apply.workable.com/clerk-dev/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                    px: "24px",
                                    children: "View Open Positions"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                display: {
                    base: "none",
                    md: "inline-flex"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rounded_corner/* RoundedCorner */.A, {
                        canvasHeight: 160,
                        bg: "#F6F9FC",
                        yPosition: "bottom",
                        xPosition: "left"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rounded_corner/* RoundedCorner */.A, {
                        canvasHeight: 160,
                        bg: "#E4F6FF",
                        yPosition: "bottom",
                        xPosition: "right"
                    })
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(91433); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);